export const useSlugStore = defineStore("slug", () => {
    const route = useRoute();

    const slug = computed(() => getSlug(route.fullPath.split("/")));

    // eslint-disable-next-line unicorn/consistent-function-scoping
    function getSlug(pathArray: string[]): string | undefined {
        if (pathArray[1] === "") {
            return undefined;
        }

        return pathArray[1];
    }

    return {
        slug,
    };
});
